import {
  Autocomplete,
  AutocompleteOption,
  Button,
  FormLabel,
  Input,
  ListItemContent,
  Modal,
  ModalDialog,
  Textarea,
  Typography,
} from "@mui/joy";
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
interface FormData {
  value: string;
  label: string;
  error?: string;
  options?: any[];
  child?: {
    label: string;
    value: string;
    error?: string;
    options: any[];
  };
  type?: string;
}
interface DynamicAddModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  values: FormData[];
}

const DynamicAddModal: React.FC<DynamicAddModalProps> = ({
  isOpen,
  onClose,
  onSave,
  values,
}) => {
  const [formData, setFormData] = useState<FormData[]>([]);
  const [selectedItems, setSelectedItems] = useState<Record<string, any | null>>({});
const [filteredOptions, setFilteredOptions] = useState<any[]>([]);

  useEffect(() => {
    const initialSelectedItems: Record<string, any | null> = {};
    values.forEach((data) => {
      const formattedlabel = data.label.replace(/\s/g, '');
      initialSelectedItems[formattedlabel] = data.value == '' ? null : data.options?.find((option) => option.name === data.value);
    });
    setSelectedItems(initialSelectedItems);
    setFormData(values);

  }, []);

  const handleInputChange = (name: string, value: any) => {
    const formattedlabel = name.replace(/\s/g, '');
    setSelectedItems((prevItems) => ({ ...prevItems, [formattedlabel]: value }));
    // Find the index of the corresponding FormData item
    const dataIndex = formData.findIndex((data) => {
       return data.label === name;
    });
    // If the corresponding FormData item is found
    if (dataIndex !== -1) {
      const filteredOptions = values[dataIndex]?.child?.options?.filter(
        (option) => {
          return option.parent === value?.id;
        }
      );
    setFilteredOptions((filteredOptions ?? []));
    }
  };

  const handleSave = () => {
    // Your save logic here
    onSave(selectedItems);
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <React.Fragment>
        <ModalDialog>
          <form>
            {formData.map((data, index) => (
              <div key={index}>
                <FormLabel sx={{ marginTop: "1rem", paddingBottom: "0.5rem" }}>
                  {data.label}
                </FormLabel>
                {data.options ? (
                  <Autocomplete
                    sx={{ width: 600 }}
                    options={data.options}
                    getOptionLabel={(option : any) => option.name}
                    isOptionEqualToValue={(option: any, value :any) =>{ 
                      return option.id === value.id;
                    }
                    }
                    renderOption={(props : any, option : any) => (
                      <div
                        key={option.id}
                        {...(props as React.HTMLAttributes<HTMLDivElement>)}
                      >
                        <ListItemContent sx={{ fontSize: "sm" }}>
                          {option.name}
                        </ListItemContent>
                      </div>
                    )}
                    onChange={(event,value) =>{
                      handleInputChange(data.label, value)
                    }
                    }
                    value={selectedItems[data.label]}
                  />
                ) : (
                  <Textarea
                    name={data.label}
                    minRows={1}
                    maxRows={10}
                    onChange={(e) =>
                      handleInputChange(data.label, e.target.value)
                    }
                  />
                )}
                <div style={{ color: "red" }}>{data.error}</div>
              </div>
            ))}
            {filteredOptions.length > 0 && (
                <div>
                    <FormLabel sx={{ marginTop: "1rem", paddingBottom: "0.5rem" }}>
                        {formData[0]?.child?.label}
                    </FormLabel>
                    <Autocomplete
                        sx={{ width: 600 }}
                        options={filteredOptions}
                        getOptionLabel={(option) => option.name}
                        isOptionEqualToValue={(option, value) =>
                            option.id === value?.id
                        }
                        renderOption={(props, option) => (
                            <div
                                key={option.id}
                                {...(props as React.HTMLAttributes<HTMLDivElement>)}
                            >
                                <ListItemContent sx={{ fontSize: "sm" }}>
                                    {option.name}
                                </ListItemContent>
                            </div>
                        )}
                        onChange={(event, value) =>
                            handleInputChange(formData[0]?.child?.label ?? "", value)
                        }
                        value={selectedItems[formData[0]?.child?.label ?? ""]}
                    />
                </div>
            )}
            <Button
              id="addButton"
              variant="outlined"
              color="neutral"
              sx={{ backgroundColor: "#484494" }}
              type="button"
              onClick={handleSave}
            >
              Toevoegen
            </Button>
            <Button
              id="addButton"
              variant="outlined"
              color="neutral"
              sx={{ backgroundColor: "#484494", marginTop: "1rem" }}
              type="button"
              onClick={onClose}
            >
              Afsluiten
            </Button>
          </form>
        </ModalDialog>
        <ToastContainer />
      </React.Fragment>
    </Modal>
  );
};

export default DynamicAddModal;
